import { render, staticRenderFns } from "./tranferStatHistory.vue?vue&type=template&id=c9ac1b66&scoped=true&"
import script from "./tranferStatHistory.vue?vue&type=script&lang=js&"
export * from "./tranferStatHistory.vue?vue&type=script&lang=js&"
import style0 from "./tranferStatHistory.vue?vue&type=style&index=0&id=c9ac1b66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9ac1b66",
  null
  
)

component.options.__file = "tranferStatHistory.vue"
export default component.exports